export const PRODUCT_TYPES_MAPPER = {
	delivery: {
		name: 'Delivery',
		id: 'DELIVERY',
		key: 'DELIVERY',
	},
	intraday: {
		name: 'Intraday',
		id: 'INTRADAY',
		key: 'INTRADAY',
	},
	mtf: {
		name: 'MTF',
		id: 'MTF',
		key: 'MTF',
	},
	btst: {
		name: 'Delivery plus',
		id: 'BTST',
		key: 'BTST',
	},
	carryforward: {
		name: 'Carryforward',
		id: 'CARRYFORWARD',
		key: 'DELIVERY',
	},
	sip: {
		name: 'SIP',
		id: 'SIP',
		key: 'SIP',
	},
};

export const PRODUCT_TYPES_LIST = [
	PRODUCT_TYPES_MAPPER.delivery,
	PRODUCT_TYPES_MAPPER.intraday,
	PRODUCT_TYPES_MAPPER.mtf,
	PRODUCT_TYPES_MAPPER.btst,
	PRODUCT_TYPES_MAPPER.carryforward,
	PRODUCT_TYPES_MAPPER.sip,
];

export const EQUITY_MARKET_SEGMENTS = {
	NSE_EQ: 'NSE_EQ',
	BSE_EQ: 'BSE_EQ',
	NSE_FO: 'NSE_FO',
	NSE_CUR: 'NSE_CUR',
};

export const EXCHANGE_LABEL_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.BSE_EQ]: 'BSE',
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: 'NSE',
	[EQUITY_MARKET_SEGMENTS.NSE_FO]: 'NSE',
	[EQUITY_MARKET_SEGMENTS.NSE_CUR]: 'NSE',
};

export const SCRIP_INSTRUMENTS = {
	EQUITY: 'EQUITIES',
	FUTURES: 'FUTSTK',
	OPTIONS: 'OPTSTK',
	OPTION_INDEX: 'OPTIDX',
	FUTURES_INDEX: 'FUTIDX',
	FUTURES_CURRENCY: 'FUTCUR',
	OPTIONS_CURRENCY: 'OPTCUR',
	INDICES: 'INDICES',
};

export const EQUITY_SCRIPS = [SCRIP_INSTRUMENTS.EQUITY];

export const FUTURES_SCRIPS = [
	SCRIP_INSTRUMENTS.FUTURES,
	SCRIP_INSTRUMENTS.FUTURES_INDEX,
	SCRIP_INSTRUMENTS.FUTURES_CURRENCY,
];

export const OPTIONS_SCRIPS = [
	SCRIP_INSTRUMENTS.OPTIONS,
	SCRIP_INSTRUMENTS.OPTION_INDEX,
	SCRIP_INSTRUMENTS.OPTIONS_CURRENCY,
];

export const INDEX_SCRIPS = [
	SCRIP_INSTRUMENTS.FUTURES_INDEX,
	SCRIP_INSTRUMENTS.OPTION_INDEX,
];
export const CURRENCY_SCRIPS = [
	SCRIP_INSTRUMENTS.FUTURES_CURRENCY,
	SCRIP_INSTRUMENTS.OPTIONS_CURRENCY,
];

export const COUNTER_ACTIONS = {
	ADD: 'ADD',
	SUBTRACT: 'SUBTRACT',
};

export const FREQUENCY_LIST = [
	{
		title: 'Weekly',
		value: 'WEEKLY',
	},
	{
		title: 'Fortnightly',
		value: 'FORTHNIGHTLY',
	},
	{
		title: 'Monthly',
		value: 'MONTHLY',
	},
	{
		title: 'Daily',
		value: 'DAILY',
	},
];

export const FREQUENCY_MAPPER = {
	WEEKLY: {
		title: 'Weekly',
		value: 'WEEKLY',
	},
	FORTHNIGHTLY: {
		title: 'Fortnightly',
		value: 'FORTHNIGHTLY',
	},
	MONTHLY: {
		title: 'Monthly',
		value: 'MONTHLY',
	},
	DAILY: {
		title: 'Daily',
		value: 'DAILY',
	},
};

export const WEEK_LIST = [
	{
		title: 'MONDAY',
		value: 'MONDAY',
	},
	{
		title: 'TUESDAY',
		value: 'TUESDAY',
	},
	{
		title: 'WEDNESDAY',
		value: 'WEDNESDAY',
	},
	{
		title: 'THURSDAY',
		value: 'THURSDAY',
	},
	{
		title: 'FRIDAY',
		value: 'FRIDAY',
	},
];

export const EDIS_PRODUCTS = ['DELIVERY'];

export const EDIS_MAPPER = {
	quantiyError: {
		title: 'Entered Qty is greater than Original Qty',
		ctaText: 'OKAY',
	},
};

export const PRODUCT_TYPE_MARGIN_MAPPER = {
	DELIVERY: 'D',
	INTRADAY: 'M',
	SIP: 'D',
	MTF: 'MF',
	CARRYFORWARD: 'D',
	MULTILEG: 'D',
	BTST: 'PT',
};

export const ORDER_MODE = {
	MODIFY: 'M',
	NEW: 'N',
};

export const MARKET_FLAG_MAPPER = {
	MARKET_FLAG: 1,
	LIMIT_FLAG: 0,
};

export const ORDER_PLACEMENT_AUTO_REDIRECT_TIME = 3000;
